export default "__VITE_ASSET__BSgRCL4H__"